import { Component } from "react";
import MuiAlert from "@mui/lab/Alert";
import foxorders_v2_logo from "../../assets/images/foxorders_v2_logo.png";
import { Button, Snackbar } from "@mui/material";
import Service from "../../controller/model/service/Service";
import { WithStylesProps } from "../utils/WithStyles";

interface FoxOrderConnectedStateInterface extends WithStylesProps {
  showAlert: boolean
  alertSeverity: "success" | "info" | "warning" | "error"
  message: string | undefined
  service: Service
  _handleCloseSnackBar: () => void
  _handleTapDisconnectButton: () => void
}

export class FoxOrderConnected extends Component<FoxOrderConnectedStateInterface> {
  render() {
    const { _handleCloseSnackBar, _handleTapDisconnectButton, alertSeverity, message, showAlert, service } = this.props;
    return (
      <div>
        <Snackbar
          open={showAlert}
          autoHideDuration={6000}
          onClose={_handleCloseSnackBar}
        >
          <MuiAlert
            severity={alertSeverity}
            onClose={_handleCloseSnackBar}
          >
            {message}
          </MuiAlert>
        </Snackbar>
        <div style={this.props.styles.rootStyle}>
          <div
            style={{ marginTop: "60px", width: "100%" }}
          >
            <img
              alt="foxOrderV2"
              src={foxorders_v2_logo}
              style={{ width: "100px" }}
            />

            <h2>Connected Establishment : {service.accountName ?? ""}</h2>

            <Button
              color="secondary"
              variant="contained"
              style={{ color: "white" }}
              onClick={_handleTapDisconnectButton}
            >
              Déconnexion
            </Button>
          </div>
        </div>
      </div>
    )
  }
}